import { render, staticRenderFns } from "./CommunicateByChannel.vue?vue&type=template&id=3d9c94eb&scoped=true"
import script from "./CommunicateByChannel.vue?vue&type=script&lang=js"
export * from "./CommunicateByChannel.vue?vue&type=script&lang=js"
import style0 from "./CommunicateByChannel.vue?vue&type=style&index=0&id=3d9c94eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c94eb",
  null
  
)

export default component.exports